import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  Image,
  Button,
} from "@chakra-ui/react";
import CloseIconBlack from "../../../assets/images/booking/x-circle.svg";
import {
  InputControl,
} from "../../../components/form/formControls";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

const schema = Yup.object().shape({
  kRate: Yup.string().required("Hệ số k là bắt buộc"),
});

const KRatePrivate = ({
  isOpen,
  onClose,
  defaultValues,
  onSubmit,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: defaultValues || {},
  });
  
  useEffect(() => {
    if (isOpen) {
      reset(defaultValues);
    }
  }, [isOpen, defaultValues, reset]);

  const [focusStates, setFocusStates] = useState({});
  const handleFocus = (field) => {
    setFocusStates((prev) => ({ ...prev, [field]: true }));
  };

  const handleBlur = (field) => {
    setFocusStates((prev) => ({ ...prev, [field]: false }));
  };

  const submitHandler = (data) => { console.log(data)
    onSubmit(data);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        // h={"625px"}
        w={"100%"}
        maxW={"625px"}
        overflowY={"auto"}
        sx={{
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            width: "4px",
            borderRadius: "50px",
            background: "var(--color-background)",
          },
          "&::-moz-scrollbar": {
            width: "4px",
          },
          "&::-moz-scrollbar-thumb": {
            width: "4px",
            borderRadius: "50px",
            background: "var(--color-background)",
          },
        }}
      >
        <form onSubmit={handleSubmit(submitHandler)}>
          <Flex flexDirection={"column"}>
            <Flex
              justifyContent={"space-between"}
              alignItems={"center"}
              gap={"10px"}
              padding={"25px 24px"}
              borderBottom={"1px solid var(--bg-line-employee)"}
            >
              <Text
                color="var(--color-header-employee)"
                fontSize={"18px"}
                fontWeight={"600"}
              >
                Cập nhật hệ số k riêng dự án
              </Text>
              <Box cursor={"pointer"} onClick={onClose}>
                <Image src={CloseIconBlack} />
              </Box>
            </Flex>
            <Box flex={1} w={"545px"} m={"24px auto"}>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  type="number"
                  label="Hệ số K"
                  placeholder="Ví dụ: 1.2 "
                  errors={errors.kRate}
                  onFocus={() => handleFocus("kRate")}
                  onBlur={() => handleBlur("kRate")}
                  state={focusStates["kRate"]}
                  register={register("kRate")}
                  mwidth={"100%"}
                  isRequired={true}
                />
              </Flex>
            </Box>
            <Flex p={"24px"} justifyContent={"flex-end"}>
              <Flex gap={"16px"}>
                <Button
                  position={"unset"}
                  p={"13px 16px 13px 20px"}
                  fontWeight={600}
                  fontSize={"15px"}
                  lineHeight={"18px"}
                  color={"var(--color-option-employee-hover)"}
                  border={"1px solid var(--color-option-employee-hover)"}
                  bg={"var(--color-main)"}
                  onClick={onClose}
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                >
                  Hủy
                </Button>
                <Button
                  position={"unset"}
                  type="submit"
                  p={"13px 16px 13px 20px"}
                  fontWeight={600}
                  fontSize={"15px"}
                  lineHeight={"18px"}
                  color={"var(--color-main)"}
                  bg={"var(--color-button)"}
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                >
                  Lưu
                </Button>
              </Flex>
            </Flex>
          </Flex>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default KRatePrivate;
